if (Shopify.designMode) {
  document.addEventListener('shopify:section:select', (event) => {
    const sectionId = event.detail.sectionId;
    if (sectionId.includes('try-before-you-buy')) {
      const modal = document.getElementById('harper-modal');
      modal.classList.remove('hidden');
    }
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const sectionId = event.detail.sectionId;
    if (sectionId.includes('try-before-you-buy')) {
      const modal = document.getElementById('harper-modal');
      modal.classList.add('hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('harper-modal');
  var closeEls = modal ? modal.querySelectorAll('[data-modal-close]') : [];
  var backdrop = document.querySelector('.harper-panel-backdrop');
  var scrollPosition = 0;

  function openModal() {
    if (modal) {
      modal.classList.remove('hidden');
      backdrop.classList.remove('hidden');
      requestAnimationFrame(() => {
        modal.classList.add('-translate-y-1/2');
        modal.classList.remove('opacity-0');
      });

      scrollPosition = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.width = '100vw';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.add('opacity-0');
    modal.classList.remove('-translate-y-1/2');

    const handleTransitionEnd = (event) => {
      if (event.target !== modal || event.propertyName !== 'opacity') return;
      backdrop.classList.add('hidden');
      modal.classList.add('hidden');
      modal.removeEventListener('transitionend', handleTransitionEnd);
    };

    modal.addEventListener('transitionend', handleTransitionEnd);

    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollPosition);

    if (window.location.hash === '#harper-modal') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  if (window.location.hash === '#harper-modal' && !Shopify.designMode) {
    openModal();
  }

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#harper-modal') {
      openModal();
    } else {
      closeModal();
    }
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  if (backdrop) {
    backdrop.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });
});
